<template>
  <div v-if="apiUser">
    <div class="layout__box__header layout__box__header--large-padding flex-wrap">
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-top mb-2 flex-wrap admin-page__box__header">
          <h3 class="mt-1">
            {{ $t("projektNadpis") }}
          </h3>
          <div
            :class="{
              disabledClick: !apiUser.isCustomerAdmin,
              disabled: !apiUser.isCustomerAdmin
            }"
            class="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
            @click="$emit('openNew')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/ico-ico-plus-white.svg" />
            </div>
            {{ $t("novyProjekt") }}
          </div>
          <div class="w-100 admin-page__box__select">
            <FormSelect
              v-if="project && customersProjects.length > 0"
              :items="customersProjects"
              :medium="true"
              :name="'projectName'"
              :selected-item="project"
              @select-item="setProject"
            />
            <div v-else-if="customersProjects.length === 0" class="font-weight-light mt-2 mb-1">
              {{ $t("zadnyProjekt") }}...
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout__box__content admin-page__box__list">
      <RouterLink
        :class="{
          disabledClick: projectLinksDisabled
        }"
        :to="projectLink('adminProjectInfo')"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-projekt.svg" />
          </div>
          <span class="font-weight-light">{{ $t("informaceOProjektu") }}</span>
        </div>
      </RouterLink>
      <RouterLink
        :class="{
          disabledClick: projectLinksDisabled
        }"
        :to="projectLink('adminProjectServicesLimits')"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-sluzba.svg" />
          </div>
          <span class="font-weight-light">{{ $t("sluzbyALimity") }}</span>
        </div>
      </RouterLink>
      <RouterLink
        :class="{
          disabledClick: projectLinksDisabled
        }"
        :to="projectLink('adminProjectUsers')"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-sprava-uzivatelu.svg" />
          </div>
          <span class="font-weight-light">{{ $t("vypisUzivatelu") }}</span>
        </div>
      </RouterLink>
      <div
        :class="{
          disabledClick: projectLinksDisabled
        }"
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-tag-gray.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("spravaTaguAParametru") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        :class="{
          disabledClick: projectLinksDisabled
        }"
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("workflowManazer") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        :class="{
          disabledClick: projectLinksDisabled
        }"
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("payloadManazer") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <RouterLink
        :class="{
          disabledClick: projectLinksDisabled
        }"
        :to="projectLink('adminProjectLogs')"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-log-operaci.svg" />
          </div>
          <span class="font-weight-light">{{ $t("logOperaci") }}</span>
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import Select from "@/components/inputs/select.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    FormSelect: Select
  },
  props: {},
  emits: ["openNew"],
  setup() {
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()
    const projectStore = useProjectStore()

    return { customerStore, authStore, projectStore }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId
    }
  },
  computed: {
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    },
    project() {
      return this.projectStore.selectedProject
    },
    projects() {
      return this.projectStore.projectList
    },
    user() {
      return this.authStore.user
    },
    apiUser() {
      return this.authStore.apiUser
    },
    customersProjects() {
      if (this.projects.filter((p) => p.customerId === this.customer.customerId).length > 0) {
        return this.projects.filter((p) => p.customerId === this.customer.customerId)
      } else {
        return []
      }
    },
    projectLinksDisabled() {
      return !this.projectId || !(this.apiUser?.isProjectAdmin || this.projects.length > 1)
    }
  },
  methods: {
    /**
     * The project pages require :projectId, and a RouterLink whose target cannot be resolved
     * throws while rendering. With no project selected the links stay on the admin menu and
     * are disabled via projectLinksDisabled.
     */
    projectLink(name) {
      return this.projectId
        ? { name, params: { projectId: this.projectId, customerId: this.customerId } }
        : { name: "adminMenu", params: { customerId: this.customerId } }
    },
    setProject(project) {
      this.projectStore.setProject(project)
    }
  }
}
</script>
